import React from "react";
import kontor from "../assets/kontor.png";
import industry from "../assets/industry.png";
import "./ImgTextBlocks.css"; 

const sections = [
  {
    title: "En heltäckande tjänst",
    text:
      "Eftersom Zaptec Portal är en molnplattform kan laddboxkillarna lösa en stor majoritet av ärenden på distans. " +
      "Det ökar inte bara effektiviteten utan säkerställer också att vi kan få ut mer information och kan ha en " +
      "proaktiv diskussion gällande ditt ärende. Det här leder till snabbare lösningar.",
    bullets: [
      "Genom Zaptec–portalen kan du visa och exportera detaljerad laddningsinformation för samtliga laddare",
      "Öppna API:er. Enkelt att lägga till önskvärd betaltjänst framöver",
      "Som partner till Laddboxkillarna får du förstklassig service, realtidsövervakning och direkt support vid oönskade händelser",
    ],
    img: kontor,
    reverse: false,
    button: null,
  },
  {
    title: "En heltäckande tjänst",
    text:
      "Eftersom Zaptec Portal är en molnplattform kan laddboxkillarna lösa en stor majoritet av ärenden på distans. " +
      "Det ökar inte bara effektiviteten utan säkerställer också att vi kan få ut mer information och kan ha en " +
      "proaktiv diskussion gällande ditt ärende. Det här leder till snabbare lösningar.",
    bullets: [
      "Genom Zaptec–portalen kan du visa och exportera detaljerad laddningsinformation för samtliga laddare",
      "Öppna API:er. Enkelt att lägga till önskvärd betaltjänst framöver",
      "Som partner till Laddboxkillarna får du förstklassig service, realtidsövervakning och direkt support vid oönskade händelser",
    ],
    img: industry,
    reverse: true,
    button: "Kontakta oss",
  },
];

export const ImgTextBlocks = () => {
  return (
    <div>
      {sections.map((sec, index) => (
        <div
          key={index}
          className={`imgtext-section ${
            sec.reverse ? "imgtext-section--reverse" : ""
          }`}
        >
          <div className="imgtext-text">
            <h2 className="imgtext-title">{sec.title}</h2>

            <p className="imgtext-body">{sec.text}</p>

            <div className="imgtext-bullets">
              {sec.bullets.map((b, idx) => (
                <div key={idx} className="imgtext-bullet">
                  <span className="imgtext-bullet-icon">✔</span>
                  <p className="imgtext-bullet-text">{b}</p>
                </div>
              ))}
            </div>

              <a href="#contact">
                    {sec.button && (
                <button className="imgtext-button">
                    {sec.button}
                </button>
            )}
              </a>
          </div>

          <div className="imgtext-image-wrapper">
            <img
              src={sec.img}
              alt=""
              className="imgtext-image"
            />
          </div>
        </div>
      ))}
    </div>
  );
};
